module.exports = __webpack_public_path__ + "20230117/img/pack.d0ec356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pack.png
// module id = dkrh
// module chunks = 1